import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import posthog, { EventName, Properties } from 'posthog-js';

@Injectable({
 providedIn: 'root',
})
export class PosthogService {
 private POSTHOG_KEY = 'phc_xdwhBvH29kLWRNEuJ63fQbhn1j0tI8tCvi6aHaBNxAr';
 private POSTHOG_HOST = 'https://analytics.ihodev.ir';
 constructor(@Inject(PLATFORM_ID) private platformId: any) {}
 init() {
  if (isPlatformBrowser(this.platformId)) {
   posthog.init(this.POSTHOG_KEY, {
    api_host: this.POSTHOG_HOST,
    person_profiles: 'identified_only',
   });
  }
 }

 sendEvent(eventName: EventName, properties: Properties | null) {
  posthog.capture(eventName, properties);
 }
}
